import { render, staticRenderFns } from "./AgreementsDashboard.vue?vue&type=template&id=3415c930&scoped=true&"
import script from "./AgreementsDashboard.vue?vue&type=script&lang=js&"
export * from "./AgreementsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsDashboard.vue?vue&type=style&index=0&id=3415c930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415c930",
  null
  
)

export default component.exports